module.exports = __webpack_public_path__ + "img/return.48adf677.jpg";